import { Pipe, PipeTransform } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectPrintFrameCount } from '@ui/products/shopping-cart-back/actions/selector';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'getFramesCountInBasket',
    standalone: false
})
export class GetFramesCountInBasketPipe implements PipeTransform {
  constructor(private store: Store) {}

  transform(photoId, value: Record<string, string>): Observable<number> {
    return this.store
      .pipe(select(selectPrintFrameCount(photoId, value)))
      .pipe(map((count) => count ?? 0));
  }
}
